let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7zydV")).then(() => parcelRequire('5Ss5z'));